import { useEffect, useState } from 'react';
import { supabase } from '@/lib/supabase';
import { Download, Trash2, Mail } from 'lucide-react';
import { toast } from 'sonner';

const STATUSES = ['new','contacted','qualified','closed','archived'];

export default function AdminLeads() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  const load = async () => {
    setLoading(true);
    const { data } = await supabase.from('leads').select('*').order('created_at', { ascending: false });
    setItems(data || []); setLoading(false);
  };
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    const { error } = await supabase.from('leads').update({ status }).eq('id', id);
    if (error) toast.error(error.message); else { toast.success('Updated'); load(); }
  };
  const remove = async (id) => {
    if (!window.confirm('Delete lead?')) return;
    const { error } = await supabase.from('leads').delete().eq('id', id);
    if (error) toast.error(error.message); else { toast.success('Deleted'); load(); }
  };

  const exportCsv = () => {
    const rows = [['Name','Email','Company','Service','Budget','Message','Status','Created']];
    items.forEach(l => rows.push([l.name, l.email, l.company, l.service, l.budget, (l.message||'').replace(/\n/g,' '), l.status, l.created_at]));
    const csv = rows.map(r => r.map(c => `"${(c||'').toString().replace(/"/g,'""')}"`).join(',')).join('\n');
    const blob = new Blob([csv], { type: 'text/csv' });
    const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = `leads-${Date.now()}.csv`; a.click();
  };

  const shown = items.filter(i => filter === 'all' || i.status === filter);

  return (
    <div>
      <div className="flex items-center justify-between flex-wrap gap-4">
        <div>
          <h1 className="font-display text-3xl text-ink-900">Contact leads</h1>
          <p className="mt-1 text-sm text-ink-500">{shown.length} of {items.length}</p>
        </div>
        <button data-testid="leads-export" onClick={exportCsv} className="inline-flex items-center gap-2 rounded-full border border-ink-100 bg-white px-5 py-2.5 text-sm"><Download className="h-4 w-4" /> Export CSV</button>
      </div>
      <div className="mt-6 flex flex-wrap gap-2">
        {['all', ...STATUSES].map(s => <button key={s} onClick={() => setFilter(s)} className={`rounded-full px-4 py-2 text-sm capitalize ${filter === s ? 'bg-ink-900 text-white' : 'border border-ink-100 bg-white text-ink-700'}`}>{s}</button>)}
      </div>
      <div className="mt-6 overflow-hidden rounded-2xl border border-ink-100 bg-white">
        {loading ? <div className="p-8 text-center text-ink-500">Loading…</div> : shown.length === 0 ? <div className="p-8 text-center text-ink-500">No leads.</div> : shown.map(l => (
          <div key={l.id} className="grid grid-cols-12 items-start gap-4 border-b border-ink-100 px-5 py-4 text-sm">
            <div className="col-span-3">
              <p className="font-medium text-ink-900">{l.name}</p>
              <a href={`mailto:${l.email}`} className="inline-flex items-center gap-1 text-xs text-cyan link-underline"><Mail className="h-3 w-3" /> {l.email}</a>
            </div>
            <div className="col-span-2 text-ink-700">{l.company}</div>
            <div className="col-span-2 text-ink-700">{l.service} <br /><span className="text-xs text-ink-400">{l.budget}</span></div>
            <div className="col-span-3 text-ink-500 line-clamp-3">{l.message}</div>
            <div className="col-span-2 flex flex-col gap-2 items-end">
              <select value={l.status} onChange={e => setStatus(l.id, e.target.value)} className="rounded-full border border-ink-100 bg-white px-3 py-1.5 text-xs">
                {STATUSES.map(s => <option key={s}>{s}</option>)}
              </select>
              <button onClick={() => remove(l.id)} className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-ink-100 text-ink-500 hover:border-red-500 hover:text-red-500"><Trash2 className="h-3.5 w-3.5" /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
